import { useQuery, useMutation } from '@tanstack/react-query';
import { bffApiClient } from '@api/bff/client';

type MqttStatusResponse = {
  connected: boolean;
};

export const useMqttDiagnostics = () => {
  const status = useQuery<MqttStatusResponse>({
    queryKey: ['mqtt-diagnostics', 'status'],
    queryFn: async () => {
      const response = await bffApiClient.get<MqttStatusResponse>(
        '/api/mqtt-diagnostics/status'
      );
      return response.data;
    },
    refetchInterval: 10_000 // poll every 10s
  });

  const reconnect = useMutation<MqttStatusResponse>({
    mutationFn: async () => {
      const response = await bffApiClient.post<MqttStatusResponse>(
        '/api/mqtt-diagnostics/reconnect'
      );
      return response.data;
    },
    onSuccess: () => {
      status.refetch();
    }
  });

  return {
    backendMqttConnected: status.data?.connected ?? null,
    isLoadingStatus: status.isLoading,
    refetchStatus: status.refetch,
    reconnect
  };
};
